import { Injectable } from '@angular/core';
import { SettingResep } from '../../models/setting-resep.model';
import { Adapter } from './adapter.service';

@Injectable({
  providedIn: 'root',
})
export class SettingResepAdapter implements Adapter<SettingResep> {
  public adapt(item: any): SettingResep {
    return {
      id: item.idSettingResep,
      notifikasiException: item.notifikasiException,
      checkFornas: item.checkFornas,
      checkSip: item.checkSip,
      disableStockHabis: item.disableStockHabis,
      statusTuslah: item.statusTuslah,
      inputHarga: item.inputHarga,
      disableResepLunas: item.disableResepLunas,
      disableHarga: item.disableHarga,
      statusKunci: item.statusKunci,
      hideHarga: item.hideHarga,
      hideHari: item.hideHari,
      inputIndikasi: item.inputIndikasi,
      inputKeterangan: item.inputKeterangan,
      inputCustomExpDate: item.inputCustomExpDate,
      hiddenArrow: item.hiddenArrow,
      notAllowStockHabis: item.notAllowStockHabis,
      allowMaxHari: item.allowMaxHari,
      notificationStockFixed: item.notificationStockFixed,
      hideStockHabis: item.hideStockHabis,
      inputCustomNamaRacikan: item.inputCustomNamaRacikan,
      inputCustomJumlahRacikan: item.inputCustomJumlahRacikan,
      notAllowPsikoNarko: item.notAllowPsikoNarko,
      notAllowFinishResep: item.notAllowFinishResep,
      validateWaktuMinum: item.validateWaktuMinum,
      validateCaraPakai: item.validateCaraPakai,
      pembulatanHargaResep: item.pembulatanHargaResep,
      allowJumlahZero: item.allowJumlahZero,
      inputManualObat: item.inputManualObat,
      inputManualObatRacikan: item.inputManualObatRacikan,
      inputBud: item.inputBud,
      notAllowDoubleObat: item.notAllowDoubleObat,
      inputKategoriTagihan: item.inputKategoriTagihan,
      statusPpn: item.statusPpn,
      valuePpn: item.valuePpn,
      statusResepPulang: item.statusResepPulang,
      potongStokRealTime: item.potongStokRealTime,
      kategoriTagihanPoli: item.kategoriTagihanPoli,
      inputTipeRacikan: item.inputTipeRacikan,
      inputStatusCito: item.inputStatusCito,
      statusBmhp: item.statusBmhp,
      hideObatKadaluarsa: item.hideObatKadaluarsa,
    };
  }
}
